.iconFrame {
    align-items: center;
    display: inline-flex;
    flex-shrink: 0;
    justify-content: center;
}
